import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button, CircularProgress, Alert } from '@mui/material';
import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const PurchaseTDSSummary = ({ fromDate, toDate, companyCode, yearCode, Tran_type, accode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isDataFetched, setIsDataFetched] = useState(false);

    const fetchPurchaseTDSSummary = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get(`${API_URL}/PurchaseTDS-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                    Tran_type: Tran_type,
                    accode: accode
                },
            });
            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No Purchase TDS data found for the selected date range.',
                });
                return;
            }
            setData(response.data);
            setIsDataFetched(true);
            openInNewWindow(response.data);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const openInNewWindow = (data) => {
        const newWindow = window.open('', '_blank');
        if (!newWindow) return;

        const columns = [
            'SR_No',
            'PSNo',
            'date',
            'Name Of Party',
            'Pan',
            'Tan',
            'Address',
            'Net',
            'CGST',
            'SGST',
            'IGST',
            'TDS',
        ];


        const exportXlsxScript = `
        function exportToXlsx() {
            const data = ${JSON.stringify(data)};
            const columnOrder = ['SR_No', 'PSNo', 'date', 'Name Of Party', 'Pan', 'Tan', 'Address','Net', 'CGST', 'SGST', 'IGST', 'TDS' ];
            const formattedData = data.map(row => {
                return {
                    ...row,
                    Net: parseFloat(row.Net) || 0,
                    CGST: parseFloat(row.CGST) || 0,
                    SGST: parseFloat(row.SGST) || 0,
                    IGST: parseFloat(row.IGST) || 0,
                    TDS: parseFloat(row.TDS) || 0,
                };
            });
    
            const ws = XLSX.utils.json_to_sheet(formattedData, { header: columnOrder, skipHeader: false });
            
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                const Net = ws[XLSX.utils.encode_cell({ r: row, c: 7 })];
                const cgstCell = ws[XLSX.utils.encode_cell({ r: row, c: 8 })]; 
                const sgstCell = ws[XLSX.utils.encode_cell({ r: row, c: 9 })]; 
                const igstCell = ws[XLSX.utils.encode_cell({ r: row, c: 10 })]; 
                const TDS = ws[XLSX.utils.encode_cell({ r: row, c: 11 })]; 
                const tcsCell = ws[XLSX.utils.encode_cell({ r: row, c: 12 })]; 
                
                if (Net) Net.z = '0.00';
                if (cgstCell) cgstCell.z = '0.00';
                if (sgstCell) sgstCell.z = '0.00';
                if (igstCell) igstCell.z = '0.00';
                if (TDS) TDS.z = '0.00';
            }
            
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SaleTCSData");
            const xlsx = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([xlsx], { type: "application/octet-stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "PurchaseTDSSummary.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    `;

        newWindow.document.write(`
            <html>
                <head>
                    <title>Purchase TDS Summary</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                       <script>${exportXlsxScript}</script>
                                        <style>
                    body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                    h2 { text-align: center; margin-top: 0; }
                    .table-container {
                        max-height: 500px;
                        overflow-y: auto;
                        margin: 20px auto;
                        width: 90%;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 6px 8px;
                        text-align: left;
                        white-space: nowrap;
                    }
                    th {
                        background-color:rgb(206, 200, 243);
                        position: sticky;
                        top: 0;
                        z-index: 2;
                        font-weight: bold;
                        font-size: 20px;
                        height: 50px;
                        text-align: center;
                    }
                    .export-btn {
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: green;
                        color: white;
                        border: none;
                        cursor: pointer;
                        margin-bottom: 20px;
                        margin-top: 20px;
                    }
                    .total-row {
                        background-color: yellow;
                        font-weight: bold;
                    }
                </style>
                </head>
                <body>
                    <h2>Purchase TDS Summary Report</h2>
                    <button class="export-btn" onclick="window.exportToXlsx()">Export to XLSX</button>
                    <table>
                        <thead>
                            <tr>
                                ${columns.map(column => `<th style="text-align: center;">${column}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map(row => {
            return `
                                    <tr>
                                        ${columns.map(column => {
                if (['Net', 'CGST', 'SGST', 'IGST', 'TDS'].includes(column)) {
                    return `<td style="text-align: right;">${formatReadableAmount(row[column] || 0)}</td>`;
                } else {
                    return `<td>${row[column] || ''}</td>`;
                }
            }).join('')}
                                    </tr>`;
        }).join('')}
                        </tbody>
                    </table>
                  
                </body>
            </html>
        `);

        newWindow.document.close();
    };

    return (
        <div style={{ marginTop: '5px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Button
                variant="contained"
                color="primary"
                onClick={fetchPurchaseTDSSummary}
                disabled={loading}
                style={{
                    width: '20%',
                    height: '60px',
                }}
            >
                {loading ? <CircularProgress size={24} /> : 'Purchase TDS Summary'}
            </Button>

            {error && <Alert severity="error">{error}</Alert>}
        </div>
    );
};

export default PurchaseTDSSummary;
